import { RegistrationCancellationList, RegistrationSession, Session } from "@/api/dtos";
import { Box, Divider, Typography, styled } from "@mui/material";
import { FC, ReactNode, useCallback, useMemo } from "react";
import SessionView from "./SessionView";
import { ISession } from ".";
import { useScopedField } from "@ngt/forms-core";
import { DEFAULT_SESSION_GROUP } from "@/constants/constants";

interface ISessionGroupProps {
    sessions: ISession[];
    title: ReactNode;
    included?: boolean;
    optional?: boolean;
    updateSelectedSessions: (session: Session, selectedSession?: RegistrationSession, selectedSessionIndex?: number, included?: boolean, optional?: boolean) => void;
    updateSelectedCancellationLists: (session: Session, selectedCancellationList?: RegistrationCancellationList, selectedCancellationListIndex?: number/*, included?: boolean, optional?: boolean*/) => void;
}

const SessionGroupBox = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2)
}));


const SessionGroup: FC<ISessionGroupProps> = ({
    title,
    sessions,
    included,
    optional,
    updateSelectedSessions,
    updateSelectedCancellationLists
}) => {
    
    const sortedSessions = useMemo(() => {
        return [...sessions].sort((a, b) => {
            
            const EarlyCareerDinner = 27;
            // Check if either session has the special ID
            if (a.session.id === EarlyCareerDinner && b.session.id !== EarlyCareerDinner) {
                return 1; // a should come after b
            }
            if (a.session.id !== EarlyCareerDinner && b.session.id === EarlyCareerDinner) {
                return -1; // b should come after a
            }

            if (a.session.startTime === b.session.startTime) {
                if (a.session.endTime === b.session.endTime) {
                    return a.session.name! < b.session.name! ? -1 : 1 
                }
                else {
                    return a.session.endTime! < b.session.endTime! ? -1 : 1 
                }
            }
            else {
                return a.session.startTime! < b.session.startTime! ? -1 : 1 
            }
        })
    }, [sessions])

    return (
        <>
            <Divider />
            <SessionGroupBox>
                <Typography variant="h6" color="secondary">
                    {title}
                </Typography>
                {
                    sortedSessions.map((session, i) => {

                        //if (session.session.traineeSession)
                        //{
                            // dont include but set variable to true

                            //true variable runs one fake sesson
                        //}

                        return (
                            <SessionView 
                                key={session.session.id}
                                session={session.session}
                                selectedSession={session.selectedSession}
                                selectedSessionIndex={session.selectedSessionIndex}
                                initialSession={session.initialSession}
                                initialSessionIndex={session.initialSessionIndex}
                                selectedCancellationList={session.selectedCancellationList}
                                selectedCancellationListIndex={session.selectedCancellationListIndex}
                                initialCancellationList={session.initialCancellationList}
                                initialCancellationListIndex={session.initialCancellationListIndex}
                                included={included}
                                optional={optional}
                                updateSelectedSessions={updateSelectedSessions}
                                updateSelectedCancellationLists={updateSelectedCancellationLists}
                            />
                        )
                    })
                }
            </SessionGroupBox>
        </>
    );
};

export default SessionGroup;